/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolStadiumIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-stadium"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M1.57 5.8L1.57 3.35Q1.57 2.98 1.88 2.77Q2.17 2.58 2.52 2.75L5 3.98Q5.38 4.17 5.38 4.58Q5.38 4.97 5 5.17L2.52 6.4Q2.17 6.58 1.88 6.38Q1.57 6.17 1.57 5.8ZM18.82 5.8L18.82 3.35Q18.82 2.98 19.13 2.77Q19.43 2.58 19.77 2.75L22.25 3.98Q22.63 4.17 22.63 4.58Q22.63 4.97 22.25 5.17L19.77 6.4Q19.43 6.58 19.13 6.38Q18.82 6.17 18.82 5.8ZM10.78 4.65L10.78 2.2Q10.78 1.82 11.07 1.63Q11.38 1.43 11.72 1.6L14.2 2.83Q14.57 3.02 14.57 3.42Q14.57 3.83 14.2 4.03L11.72 5.25Q11.38 5.42 11.07 5.22Q10.78 5.03 10.78 4.65ZM8.15 22.07Q5.92 21.77 3.8 21Q1.68 20.23 1.68 19L1.68 10Q1.68 9.32 2.49 8.71Q3.3 8.1 4.7 7.65Q6.1 7.2 7.99 6.94Q9.88 6.67 12.01 6.67Q14.15 6.67 16.02 6.94Q17.9 7.2 19.3 7.65Q20.7 8.1 21.51 8.71Q22.32 9.32 22.32 10L22.32 19Q22.32 20.23 20.19 21.01Q18.05 21.8 15.82 22.1Q15.63 22.13 15.47 21.99Q15.32 21.85 15.32 21.65L15.32 20.4Q15.32 19.02 14.35 18.05Q13.38 17.07 12 17.07Q10.63 17.07 9.65 18.05Q8.68 19.02 8.68 20.4L8.68 21.63Q8.68 21.82 8.51 21.96Q8.35 22.1 8.15 22.07ZM12 10.68Q14.13 10.68 15.46 10.46Q16.8 10.25 17.85 9.93Q17.2 9.75 15.8 9.54Q14.4 9.32 12 9.32Q9.6 9.32 8.2 9.54Q6.8 9.75 6.15 9.93Q7.2 10.25 8.54 10.46Q9.88 10.68 12 10.68Z" fill={color} />
    </svg>
  );
}
